import React, { useState, useCallback } from "react"
import { Menu } from "./menu/menu.js"
import { MobileMenu } from "./mobileMenu/mobileMenu.js"
import * as style from "./header.module.css"
import { MobileMenuContent } from "./mobileMenu/mobileMenuContent.js"
import Logo from "../../images/chainide.svg"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { StaticImage } from "gatsby-plugin-image"
import headerPicture from './headerPicture@2x.png'
import headerMobile from './headerMobile@2x.png'


export function Header() {
  const [show, setShow] = useState(false)
    const { t } = useTranslation()
    const events = t("events.yuanyuzhou")

  const toggleShow = useCallback(
    e => {
      e.stopPropagation()
      e.preventDefault()
      setShow(!show)
    },
    [show]
  )
  return (
    <header className={style.header}>
      {events && <a href="https://metabootcamp.chainide.com/" target="view_window"  style={{cursor:'pointer'}}><div className={style.eventsPC}><img className={style.img} src={headerPicture}  placeholder="blur"
            alt="Ant OC Logo"/></div>
      <div className={style.eventsMobile}><img className={style.img} objectFit="cover" src={headerMobile} objectFit="cover" /></div>
      </a>}
      <div className={style.headerContent}>
        <div className={style.logoWrapper}>
          <Logo />
        </div>
        <Menu />
        <MobileMenu onTab={toggleShow} />
      </div>
      <MobileMenuContent show={show} />
    </header>
  )
}
